import { __rest, __assign, __spread } from 'tslib';
import { BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { Injectable, Component, Input, NgModule, ɵɵdefineInjectable, ɵɵinject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@angular/common';

var _c0 = function (a0) { return [a0]; };
function BreadcrumbComponent_ng_container_2_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var breadcrumb_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(2, _c0, breadcrumb_r1.route));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", breadcrumb_r1.label, " ");
} }
function BreadcrumbComponent_ng_container_2_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var breadcrumb_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(breadcrumb_r1.label);
} }
function BreadcrumbComponent_ng_container_2_li_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.separator, "");
} }
var _c1 = function (a0) { return { active: a0 }; };
function BreadcrumbComponent_ng_container_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_ng_container_2_li_1_a_1_Template, 2, 4, "a", 5);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_ng_container_2_li_1_ng_template_2_Template, 2, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵtemplate(4, BreadcrumbComponent_ng_container_2_li_1_span_4_Template, 2, 1, "span", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    var _r5 = ɵngcc0.ɵɵreference(3);
    var isLast_r2 = ɵngcc0.ɵɵnextContext().last;
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c1, isLast_r2));
    ɵngcc0.ɵɵattribute("aria-current", isLast_r2 ? "page" : null);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !isLast_r2)("ngIfElse", _r5);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !isLast_r2);
} }
function BreadcrumbComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbComponent_ng_container_2_li_1_Template, 5, 7, "li", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    var breadcrumb_r1 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !breadcrumb_r1.skip);
} }
var BreadcrumbService = /** @class */ (function () {
    function BreadcrumbService(activatedRoute, router) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.baseHref = '/';
        /**
         * Store holds all dynamic breadcrumb updates, so that they can be resued across App routes
         * When breadcrumb is set in between any intermediate components, we use store data to power breadcrumbs
         * TO REVISIT
         */
        this.store = [];
        /**
         * currentBreadcrumbs holds the current route's breadcrumb definition
         * This is updated whenever breadcrumbs are updated dynamically a new stream is emitted
         */
        this.currentBreadcrumbs = [];
        /**
         * Breadcrumbs observable to be subscibed by component
         */
        this.breadcrumbs = new BehaviorSubject([]);
        this.breadcrumbs$ = this.breadcrumbs.asObservable();
        this.pathParamPrefix = ':';
        this.pathParamRegexIdentifier = '/:[^/]+';
        this.pathParamRegexReplacer = '/[^/]+';
        /**
         * If true, breacrumb is formed even without any configuration
         * Default mapping is same as route path
         */
        this.defaultMapping = true;
        this.setBaseBreadcrumb();
        this.detectRouteChanges();
    }
    /**
     * update a breadcrumb label by passing route
     * route is same as angular route definition for a route
     * Ex: /mentor or /mentor/:id/edit
     */
    /**
     * update a breadcrumb label by passing route
     * route is same as angular route definition for a route
     * Ex: /mentor or /mentor/:id/edit
     * @param {?} route
     * @param {?} label
     * @return {?}
     */
    BreadcrumbService.prototype.set = /**
     * update a breadcrumb label by passing route
     * route is same as angular route definition for a route
     * Ex: /mentor or /mentor/:id/edit
     * @param {?} route
     * @param {?} label
     * @return {?}
     */
    function (route, label) {
        /** @type {?} */
        var storeItem = this.buildRouteRegex({ route: route, label: label });
        this.updateStore(storeItem);
    };
    /**
     * skip a breadcrumb visibility by passing route
     * Ex: skip('/mentor') or skip('/mentor/:id/edit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skip('/mentor/:id/edit', false)
     */
    /**
     * skip a breadcrumb visibility by passing route
     * Ex: skip('/mentor') or skip('/mentor/:id/edit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skip('/mentor/:id/edit', false)
     * @param {?} route
     * @param {?=} skip
     * @return {?}
     */
    BreadcrumbService.prototype.skip = /**
     * skip a breadcrumb visibility by passing route
     * Ex: skip('/mentor') or skip('/mentor/:id/edit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skip('/mentor/:id/edit', false)
     * @param {?} route
     * @param {?=} skip
     * @return {?}
     */
    function (route, skip) {
        if (skip === void 0) { skip = true; }
        /** @type {?} */
        var storeItem = this.buildRouteRegex({ route: route, skip: skip });
        this.updateStore(storeItem);
    };
    /**
     * update a breadcrumb label by passing breadcrumbAlias, that is defined during application routing
     * setForAlias('mentor', 'Enabler')
     */
    /**
     * update a breadcrumb label by passing breadcrumbAlias, that is defined during application routing
     * setForAlias('mentor', 'Enabler')
     * @param {?} alias
     * @param {?} label
     * @return {?}
     */
    BreadcrumbService.prototype.setForAlias = /**
     * update a breadcrumb label by passing breadcrumbAlias, that is defined during application routing
     * setForAlias('mentor', 'Enabler')
     * @param {?} alias
     * @param {?} label
     * @return {?}
     */
    function (alias, label) {
        this.updateStore({ alias: alias, label: label });
    };
    /**
     * update a breadcrumb visibilty by passing breadcrumbAlias, that is defined during application routing
     * skipForAlias('mentorEdit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skipForAlias('mentorEdit', false)
     */
    /**
     * update a breadcrumb visibilty by passing breadcrumbAlias, that is defined during application routing
     * skipForAlias('mentorEdit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skipForAlias('mentorEdit', false)
     * @param {?} alias
     * @param {?=} skipBreadcrumb
     * @return {?}
     */
    BreadcrumbService.prototype.skipForAlias = /**
     * update a breadcrumb visibilty by passing breadcrumbAlias, that is defined during application routing
     * skipForAlias('mentorEdit')
     * If you need to make a hidden breadcrumb visible, pass optional second param as false
     * skipForAlias('mentorEdit', false)
     * @param {?} alias
     * @param {?=} skipBreadcrumb
     * @return {?}
     */
    function (alias, skipBreadcrumb) {
        if (skipBreadcrumb === void 0) { skipBreadcrumb = true; }
        this.updateStore({ alias: alias, skipBreadcrumb: skipBreadcrumb });
    };
    /**
     * @private
     * @return {?}
     */
    BreadcrumbService.prototype.setBaseBreadcrumb = /**
     * @private
     * @return {?}
     */
    function () {
        /** @type {?} */
        var baseConfig = this.router.config.find((/**
         * @param {?} pathConfig
         * @return {?}
         */
        function (pathConfig) { return pathConfig.path === ''; }));
        if (baseConfig && baseConfig.data) {
            var _a = baseConfig.data, breadcrumb = _a.breadcrumb, breadcrumbAlias = _a.breadcrumbAlias, _b = _a.skipBreadcrumb, skipBreadcrumb = _b === void 0 ? false : _b;
            this.baseBreadcrumb = {
                label: breadcrumb,
                route: this.baseHref,
                alias: breadcrumbAlias,
                skip: skipBreadcrumb
            };
        }
    };
    /**
     * @private
     * @return {?}
     */
    BreadcrumbService.prototype.detectRouteChanges = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        this.router.events
            .pipe(filter((/**
         * @param {?} event
         * @return {?}
         */
        function (event) { return event instanceof NavigationEnd; })), distinctUntilChanged())
            .subscribe((/**
         * @param {?} event
         * @return {?}
         */
        function (event) {
            _this.currentBreadcrumbs = _this.baseBreadcrumb ? [_this.baseBreadcrumb] : [];
            _this.setBreadcrumbs(_this.activatedRoute.root, _this.baseHref);
        }));
    };
    /**
     * @private
     * @param {?} activatedRoute
     * @param {?} url
     * @return {?}
     */
    BreadcrumbService.prototype.setBreadcrumbs = /**
     * @private
     * @param {?} activatedRoute
     * @param {?} url
     * @return {?}
     */
    function (activatedRoute, url) {
        if (activatedRoute.routeConfig && activatedRoute.routeConfig.path) {
            /** @type {?} */
            var breadcrumbItem = this.prepareBreadcrumbItem(activatedRoute, url);
            this.currentBreadcrumbs.push(breadcrumbItem);
            if (activatedRoute.firstChild) {
                return this.setBreadcrumbs(activatedRoute.firstChild, breadcrumbItem.route + '/');
            }
        }
        else if (activatedRoute.firstChild) {
            return this.setBreadcrumbs(activatedRoute.firstChild, url);
        }
        /** @type {?} */
        var breacrumbsToShow = this.currentBreadcrumbs.filter((/**
         * @param {?} breadcrumb
         * @return {?}
         */
        function (breadcrumb) { return !breadcrumb.skip && breadcrumb.label; }));
        this.breadcrumbs.next(breacrumbsToShow);
    };
    /**
     * @private
     * @param {?} activatedRoute
     * @param {?} url
     * @return {?}
     */
    BreadcrumbService.prototype.prepareBreadcrumbItem = /**
     * @private
     * @param {?} activatedRoute
     * @param {?} url
     * @return {?}
     */
    function (activatedRoute, url) {
        var _a = this.parseRouteConfig(activatedRoute.routeConfig), path = _a.path, breadcrumb = _a.breadcrumb, breadcrumbAlias = _a.breadcrumbAlias, skipBreadcrumb = _a.skipBreadcrumb;
        /** @type {?} */
        var pathSegement = this.resolvePathSegment(path, activatedRoute);
        /** @type {?} */
        var route = "" + url + pathSegement;
        /** @type {?} */
        var label = this.getFromStore(breadcrumbAlias, route, 'label') || breadcrumb || (this.defaultMapping ? pathSegement : '');
        /** @type {?} */
        var skip = this.getFromStore(breadcrumbAlias, route, 'skip') || skipBreadcrumb;
        return { label: label, route: route, skip: skip, alias: breadcrumbAlias };
    };
    /**
     * breadcrumbs can be declared either on module or its children with empty path
     * When both are defined child empty path takes precedence
     * { path: 'home', loadChildren: './home/home.module#HomeModule' , data: {breadcrumb: "Defined On Module"}}
     *                             ----OR----
     * children: [
        { path: '', component: ShowUserComponent, data: {breadcrumb: "Defined On Child" }
      ]
     */
    /**
     * breadcrumbs can be declared either on module or its children with empty path
     * When both are defined child empty path takes precedence
     * { path: 'home', loadChildren: './home/home.module#HomeModule' , data: {breadcrumb: "Defined On Module"}}
     *                             ----OR----
     * children: [
     * { path: '', component: ShowUserComponent, data: {breadcrumb: "Defined On Child" }
     * ]
     * @private
     * @param {?} routeConfig
     * @return {?}
     */
    BreadcrumbService.prototype.parseRouteConfig = /**
     * breadcrumbs can be declared either on module or its children with empty path
     * When both are defined child empty path takes precedence
     * { path: 'home', loadChildren: './home/home.module#HomeModule' , data: {breadcrumb: "Defined On Module"}}
     *                             ----OR----
     * children: [
     * { path: '', component: ShowUserComponent, data: {breadcrumb: "Defined On Child" }
     * ]
     * @private
     * @param {?} routeConfig
     * @return {?}
     */
    function (routeConfig) {
        var path = routeConfig.path, _a = routeConfig.data, data = _a === void 0 ? {} : _a;
        var breadcrumb = data.breadcrumb, breadcrumbAlias = data.breadcrumbAlias, _b = data.skipBreadcrumb, skipBreadcrumb = _b === void 0 ? false : _b;
        // To handle a module with empty child route
        if (routeConfig.loadChildren) {
            /** @type {?} */
            var baseChild = routeConfig._loadedConfig.routes.find((/**
             * @param {?} route
             * @return {?}
             */
            function (route) { return route.path === ''; }));
            /** @type {?} */
            var baseChildData = baseChild && baseChild.data;
            if (baseChildData) {
                breadcrumb = baseChildData.breadcrumb || breadcrumb;
                breadcrumbAlias = baseChildData.breadcrumbAlias || breadcrumbAlias;
                skipBreadcrumb = baseChildData.skipBreadcrumb || skipBreadcrumb;
            }
        }
        // To handle a component with empty child route
        if (routeConfig.children) {
            /** @type {?} */
            var baseChild = routeConfig.children.find((/**
             * @param {?} route
             * @return {?}
             */
            function (route) { return route.path === ''; }));
            /** @type {?} */
            var baseChildData = baseChild && baseChild.data;
            if (baseChildData) {
                breadcrumb = baseChildData.breadcrumb || breadcrumb;
                breadcrumbAlias = baseChildData.breadcrumbAlias || breadcrumbAlias;
                skipBreadcrumb = baseChildData.skipBreadcrumb || skipBreadcrumb;
            }
        }
        return {
            breadcrumb: breadcrumb,
            breadcrumbAlias: breadcrumbAlias,
            skipBreadcrumb: skipBreadcrumb,
            path: path
        };
    };
    /**
     * @private
     * @param {?} breadcrumbAlias
     * @param {?} route
     * @param {?} prop
     * @return {?}
     */
    BreadcrumbService.prototype.getFromStore = /**
     * @private
     * @param {?} breadcrumbAlias
     * @param {?} route
     * @param {?} prop
     * @return {?}
     */
    function (breadcrumbAlias, route, prop) {
        /** @type {?} */
        var matchingItem;
        if (breadcrumbAlias) {
            matchingItem = this.store.find((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return item.alias === breadcrumbAlias; }));
        }
        if (!matchingItem && route) {
            matchingItem = this.store.find((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                return (item.route && item.route === route) || (item.routeRegex && new RegExp(item.routeRegex).test(route + '/'));
            }));
        }
        if (matchingItem) {
            return matchingItem[prop];
        }
        return;
    };
    /**
     * regex string is built, if route has path params(contains with ':')
     */
    /**
     * regex string is built, if route has path params(contains with ':')
     * @private
     * @param {?} __0
     * @return {?}
     */
    BreadcrumbService.prototype.buildRouteRegex = /**
     * regex string is built, if route has path params(contains with ':')
     * @private
     * @param {?} __0
     * @return {?}
     */
    function (_a) {
        var route = _a.route, props = __rest(_a, ["route"]);
        // ensure leading slash is provided in the path
        if (!route.startsWith('/')) {
            route = '/' + route;
        }
        if (route.includes(this.pathParamPrefix)) {
            /** @type {?} */
            var routeRegex = route.replace(new RegExp(this.pathParamRegexIdentifier, 'g'), this.pathParamRegexReplacer);
            return __assign({ routeRegex: routeRegex }, props);
        }
        else {
            return __assign({ route: route }, props);
        }
    };
    /**
     * Update current breadcrumb definition and emit a new stream of breadcrumbs
     * Also update the store to reuse dynamic declarations
     */
    /**
     * Update current breadcrumb definition and emit a new stream of breadcrumbs
     * Also update the store to reuse dynamic declarations
     * @private
     * @param {?} spec
     * @return {?}
     */
    BreadcrumbService.prototype.updateStore = /**
     * Update current breadcrumb definition and emit a new stream of breadcrumbs
     * Also update the store to reuse dynamic declarations
     * @private
     * @param {?} spec
     * @return {?}
     */
    function (spec) {
        var alias = spec.alias, route = spec.route, routeRegex = spec.routeRegex, prop = __rest(spec, ["alias", "route", "routeRegex"]);
        /** @type {?} */
        var breadcrumbItemIndex;
        /** @type {?} */
        var storeItemIndex;
        // identify macthing breadcrumb and store item
        if (alias) {
            breadcrumbItemIndex = this.currentBreadcrumbs.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return alias === item.alias; }));
            storeItemIndex = this.store.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return alias === item.alias; }));
        }
        else if (route) {
            breadcrumbItemIndex = this.currentBreadcrumbs.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return route === item.route; }));
            storeItemIndex = this.store.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return route === item.route; }));
        }
        else if (routeRegex) {
            breadcrumbItemIndex = this.currentBreadcrumbs.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return new RegExp(routeRegex).test(item.route + '/'); }));
            storeItemIndex = this.store.findIndex((/**
             * @param {?} item
             * @return {?}
             */
            function (item) { return routeRegex === item.routeRegex; }));
        }
        // if breadcrumb is present in current breadcrumbs update it and emit new stream
        if (breadcrumbItemIndex > -1) {
            this.currentBreadcrumbs[breadcrumbItemIndex] = __assign({}, this.currentBreadcrumbs[breadcrumbItemIndex], prop);
            /** @type {?} */
            var breacrumbsToShow = this.currentBreadcrumbs.filter((/**
             * @param {?} breadcrumb
             * @return {?}
             */
            function (breadcrumb) { return !breadcrumb.skip && breadcrumb.label; }));
            this.breadcrumbs.next(__spread(breacrumbsToShow));
        }
        // If the store already has this route definition update it, else add
        if (storeItemIndex > -1) {
            this.store[storeItemIndex] = __assign({}, this.store[storeItemIndex], prop);
        }
        else {
            this.store.push(__assign({ alias: alias, route: route, routeRegex: routeRegex }, prop));
        }
    };
    /**
     * @private
     * @param {?} pathSegement
     * @param {?} activatedRoute
     * @return {?}
     */
    BreadcrumbService.prototype.resolvePathSegment = /**
     * @private
     * @param {?} pathSegement
     * @param {?} activatedRoute
     * @return {?}
     */
    function (pathSegement, activatedRoute) {
        // if the path segment is a route param, read the param value from url
        if (pathSegement.startsWith(this.pathParamPrefix)) {
            return activatedRoute.snapshot.params[pathSegement.slice(1)];
        }
        return pathSegement;
    };
    /** @nocollapse */
    BreadcrumbService.ctorParameters = function () { return [
        { type: ActivatedRoute },
        { type: Router }
    ]; };
    /** @nocollapse */ BreadcrumbService.ngInjectableDef = ɵɵdefineInjectable({ factory: function BreadcrumbService_Factory() { return new BreadcrumbService(ɵɵinject(ActivatedRoute), ɵɵinject(Router)); }, token: BreadcrumbService, providedIn: "root" });
BreadcrumbService.ɵfac = function BreadcrumbService_Factory(t) { return new (t || BreadcrumbService)(ɵngcc0.ɵɵinject(ɵngcc1.ActivatedRoute), ɵngcc0.ɵɵinject(ɵngcc1.Router)); };
BreadcrumbService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbService, factory: function (t) { return BreadcrumbService.ɵfac(t); }, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.ActivatedRoute }, { type: ɵngcc1.Router }]; }, null); })();
    return BreadcrumbService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbComponent = /** @class */ (function () {
    function BreadcrumbComponent(breadcrumbService) {
        this.breadcrumbService = breadcrumbService;
        /**
         * If true, breacrumb is formed even without any configuration
         * Default mapping is same as route path with intial letter capitalized
         *
         */
        this.defaultMapping = true;
        /**
         * separator between breadcrumbs
         * defaults to '/'. Other options could be '.' or '-' or '>' etc.
         *
         */
        this.separator = '/';
    }
    /**
     * @return {?}
     */
    BreadcrumbComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.breadcrumbService.defaultMapping = this.defaultMapping;
        this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
    };
    /** @nocollapse */
    BreadcrumbComponent.ctorParameters = function () { return [
        { type: BreadcrumbService }
    ]; };
    BreadcrumbComponent.propDecorators = {
        defaultMapping: [{ type: Input }],
        separator: [{ type: Input }]
    };
BreadcrumbComponent.ɵfac = function BreadcrumbComponent_Factory(t) { return new (t || BreadcrumbComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbService)); };
BreadcrumbComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbComponent, selectors: [["xng-breadcrumb"]], inputs: { defaultMapping: "defaultMapping", separator: "separator" }, decls: 4, vars: 3, consts: [["aria-label", "breadcrumb"], [1, "breadcrumb"], [4, "ngFor", "ngForOf"], ["class", "breadcrumb-item", 3, "ngClass", 4, "ngIf"], [1, "breadcrumb-item", 3, "ngClass"], ["routerLinkActive", "active", 3, "routerLink", 4, "ngIf", "ngIfElse"], ["lastRoute", ""], ["class", "separator", "aria-hidden", "true", 4, "ngIf"], ["routerLinkActive", "active", 3, "routerLink"], [1, "current-path"], ["aria-hidden", "true", 1, "separator"]], template: function BreadcrumbComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "nav", 0);
        ɵngcc0.ɵɵelementStart(1, "ol", 1);
        ɵngcc0.ɵɵtemplate(2, BreadcrumbComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.breadcrumbs$));
    } }, directives: [ɵngcc2.NgForOf, ɵngcc2.NgIf, ɵngcc2.NgClass, ɵngcc1.RouterLinkWithHref, ɵngcc1.RouterLinkActive], pipes: [ɵngcc2.AsyncPipe], styles: [".breadcrumb[_ngcontent-%COMP%]{display:flex;flex-wrap:wrap}ol[_ngcontent-%COMP%]{margin:0;padding:0;list-style:none}a[_ngcontent-%COMP%]{cursor:pointer;box-sizing:border-box;opacity:.75;white-space:nowrap;color:inherit;background:0 0;line-height:36px;padding:0 8px;outline:0;text-decoration:none}a[_ngcontent-%COMP%]:focus, a[_ngcontent-%COMP%]:hover{text-decoration:unset;opacity:1}.current-path[_ngcontent-%COMP%]{box-sizing:border-box;white-space:nowrap;color:inherit;background:0 0;line-height:36px;padding:0 8px;opacity:.75}.separator[_ngcontent-%COMP%]{display:inline-block;opacity:.5;font-weight:400;font-style:normal;font-size:1.1em}"] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbComponent, [{
        type: Component,
        args: [{
                selector: 'xng-breadcrumb',
                template: "<nav aria-label=\"breadcrumb\">\n  <ol class=\"breadcrumb\">\n    <ng-container *ngFor=\"let breadcrumb of breadcrumbs$ | async; last as isLast\">\n      <li class=\"breadcrumb-item\" [ngClass]=\"{ active: isLast }\" [attr.aria-current]=\"isLast ? 'page' : null\" *ngIf=\"!breadcrumb.skip\">\n        <a *ngIf=\"!isLast; else lastRoute\" [routerLink]=\"[breadcrumb.route]\" routerLinkActive=\"active\">\n          {{ breadcrumb.label }}\n        </a>\n        <ng-template #lastRoute>\n          <label class=\"current-path\">{{ breadcrumb.label }}</label>\n        </ng-template>\n        <span class=\"separator\" aria-hidden=\"true\" *ngIf=\"!isLast\"> {{ separator }}</span>\n      </li>\n    </ng-container>\n  </ol>\n</nav>\n",
                styles: [".breadcrumb{display:flex;flex-wrap:wrap}ol{margin:0;padding:0;list-style:none}a{cursor:pointer;box-sizing:border-box;opacity:.75;white-space:nowrap;color:inherit;background:0 0;line-height:36px;padding:0 8px;outline:0;text-decoration:none}a:focus,a:hover{text-decoration:unset;opacity:1}.current-path{box-sizing:border-box;white-space:nowrap;color:inherit;background:0 0;line-height:36px;padding:0 8px;opacity:.75}.separator{display:inline-block;opacity:.5;font-weight:400;font-style:normal;font-size:1.1em}"]
            }]
    }], function () { return [{ type: BreadcrumbService }]; }, { defaultMapping: [{
            type: Input
        }], separator: [{
            type: Input
        }] }); })();
    return BreadcrumbComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var BreadcrumbModule = /** @class */ (function () {
    function BreadcrumbModule() {
    }
BreadcrumbModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: BreadcrumbModule });
BreadcrumbModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function BreadcrumbModule_Factory(t) { return new (t || BreadcrumbModule)(); }, imports: [[CommonModule, RouterModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(BreadcrumbModule, { declarations: function () { return [BreadcrumbComponent]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [BreadcrumbComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BreadcrumbModule, [{
        type: NgModule,
        args: [{
                declarations: [BreadcrumbComponent],
                imports: [CommonModule, RouterModule],
                exports: [BreadcrumbComponent]
            }]
    }], function () { return []; }, null); })();
    return BreadcrumbModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BreadcrumbService, BreadcrumbComponent, BreadcrumbModule };

//# sourceMappingURL=xng-breadcrumb.js.map